import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function fillControlClass(field: SchemaField, className: string): string {
  return field.height === 'fill' ? `${className} flex-1` : className
}
